module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1032-2e1f625f29e63aa24aaf3ad7a6a660fd.png";